import {http} from '@/http'
import {Storage, Analytics} from '../../../core/Utils'

const oauth2 = {
    url: process.env.VUE_APP_SERVICES_AUTH_ENDPOINT, // Your API login endpoint
    client_id: process.env.VUE_APP_SSO_AUTH_CLIENT_ID, // change with your Microsoft office Client ID
    redirect_uri: process.env.VUE_APP_SSO_AUTH_REDICT_URI, // Your client app URL
    defaultUrlParams: ['response_type', 'client_id', 'redirect_uri', 'scope', 'state', 'nonce'],
    authorizationEndpoint: process.env.VUE_APP_SSO_AUTH_ENDPOINT,
    scope: process.env.VUE_APP_SSO_AUTH_SCOPES? process.env.VUE_APP_SSO_AUTH_SCOPES.split(",") : [],
    scopeDelimiter: " ",
    state: process.env.VUE_APP_SSO_AUTH_NAME,
    nonce: process.env.VUE_APP_SSO_AUTH_NAME,
    response_type: "id_token token",
    responseParams: {
        id_token: 'id_token',
        clientId: 'clientId',
        redirectUri: 'redirectUri',
        access_token: 'access_token',
        scope: "scope",
        state: "state",
    }
}

const resource = "/api/auth";
const ID_TOKEN_HINT_KEY = "sso_id_token_hint";

export default {
    login(username, password) {
        return http.post(`${resource}/login/`, {email: username, password: password})
            .then(response => {
                    this.storeUserCredentials(response.user);
                    return response
                }
            );
    },
    loginWithToken(token) {
        return http.post(`${resource}/refreshtoken/`, {refreshToken: token})
            .then(response => {
                const user = Storage.getUser()
                // get new access token
                user.token = response.user.token
                Storage.setUser(user)
                return user
            });
    },
    storeUserCredentials(credentials) {
        Storage.setUser(credentials)
        Analytics.loadUserId()
    },
    checkJWTtoken(token) {
        return http.post(`${resource}/token/verify/`, {token: token})
    },
    createUser(payload) {
        return http.post(`${resource}`, payload)
    },
    logout() {
        // remove all data from local storage (including user) to log out
        Storage.clearAll()
        // remove Google Analytics User ID
        Analytics.clearUserId()
    },
    storeIdTokenHint() {
        const payload = this.getSSOPayload()
        const idToken = payload && payload.id_token ? payload.id_token : null
        if (idToken) {
            localStorage.setItem(ID_TOKEN_HINT_KEY, idToken)
        }
        return idToken
    },
    getIdTokenHint() {
        return localStorage.getItem(ID_TOKEN_HINT_KEY)
    },
    redirectToLogoutURL() {
        const idTokenHint = this.getIdTokenHint()
        localStorage.removeItem(ID_TOKEN_HINT_KEY)
        // remove all data from local storage (including user) to log out
        Storage.clearAll()
        // remove Google Analytics User ID
        Analytics.clearUserId()

        const params = [
            `id_token_hint=${encodeURIComponent(idTokenHint || '')}`,
            `post_logout_redirect_uri=${encodeURIComponent(process.env.VUE_APP_SSO_LOGOUT_REDIRECT_URI)}`
        ]
        const url = `${process.env.VUE_APP_SSO_LOGOUT_ENDPOINT}?${params.join('&')}`
        location.href = url
    },
    loginSSOJAUSA() {
        const payload = this.getValidParamsFromPayload()
        if(Object.keys(payload).length >2){
            return http.post(process.env.VUE_APP_SERVICES_AUTH_ENDPOINT, payload)
            .then(response => {
                if(response.success)
                    this.storeUserCredentials(response.user)
                    return response
                }
            );
        }
    },
    getFullUrlPath(location) {
        const isHttps = location.protocol === 'https:'
        return location.protocol + '//' + location.hostname +
        ':' + (location.port || (isHttps ? '443' : '80')) +
        (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname)
    },
    parseQueryString(str) {
        const obj = {}
        let key
        let value
        (str || '').split('&').forEach((keyValue) => {
            if (keyValue) {
                value = keyValue.split('=')
                key = decodeURIComponent(value[0])
                obj[key] = (!!value[1]) ? decodeURIComponent(value[1]) : true
            }
        })
        return obj
    },
    objectExtend(a, b) {
        // Don't touch 'null' or 'undefined' objects.
        if (a == null || b == null) {
            return a
        }

        Object.keys(b).forEach(function (key) {
            if (Object.prototype.toString.call(b[key]) == '[object Object]') {
            if (Object.prototype.toString.call(a[key]) != '[object Object]') {
                a[key] = b[key]
            } else {
                a[key] = objectExtend(a[key], b[key])
            }
            } else {
            a[key] = b[key]
            }
        });

        return a
    },
    buildQueryString () {
        const parsedParams = []
        for (const paramName of oauth2.defaultUrlParams) {
          const paramValue = oauth2[paramName]
          if (paramName === 'scope' && Array.isArray(paramValue)) {
            paramValue = paramValue.join(oauth2.scopeDelimiter)
          }
          parsedParams.push(encodeURIComponent(paramName) + '=' + encodeURIComponent(paramValue))
        }
        return parsedParams.join('&')
    },
    redirecToAuthorizeURL() {
        const url = [oauth2.authorizationEndpoint, this.buildQueryString()].join('?')
        location.href = url
    },
    getSSOPayload(){
        const popupWindowPath = this.getFullUrlPath(window.location)
        var redirectUriParser = document.createElement('a')
        redirectUriParser.href = process.env.VUE_APP_SSO_AUTH_REDICT_URI
        var redirectUriPath = this.getFullUrlPath(redirectUriParser)
        if (popupWindowPath === redirectUriPath) {
            if (window.location.search || window.location.hash) {
                var query = this.parseQueryString(window.location.search.substring(1).replace(/(\/sso\/)/, ''))
                var hash = this.parseQueryString(window.location.hash.substring(1).replace(/(\/sso\/)/, ''))
                var params = this.objectExtend({}, query)
                params = this.objectExtend(params, hash)

                if (params.error) {
                    return {}
                } else {
                    return params
                }
            } else {
                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found.'))
            }
        }
    },
    getValidParamsFromPayload(){
        const payload = {}
        const oauth = this.getSSOPayload()
        for (var key in oauth2.responseParams) {
        
            switch(key) {
                case 'clientId':
                    payload[key] = process.env.VUE_APP_SSO_AUTH_CLIENT_ID;
                    break
                case 'redirectUri':
                    payload[key] = process.env.VUE_APP_SSO_AUTH_REDICT_URI;
                    break
                default:
                payload[key] = oauth[key];
            }
        }
        return payload
    }
}